/* file description */
import useMetaStore from '@/store/useMetaStore';
import { useEffect, useMemo, useState } from 'react';

const useRowSelection = (props: any, setSelectedRows: any) => {
  // const [rowSel, setRowSel] = useState({});
  const selectedRowKeysConfig = getSelectedRowKeys({ selectedRowKeys: props.selectedRowKeys });
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[] | undefined>(selectedRowKeysConfig);
  const { eventsConfig } = useMetaStore();
  
  // const selectedRowKeysConfig = getSelectedRowKeys({ selectedRowKeys: props.selectedRowKeys });
  return useMemo(() => {
    if (props.selectType === 'checkbox') {
      return {
        rowSelection: {
          type: 'checkbox',
          onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
            setSelectedRows(selectedRows);
            setSelectedRowKeys(selectedRowKeys);
            props?.onSelectedRows && props.onSelectedRows(selectedRowKeys, selectedRows);
            eventsConfig?.rowSelection && eventsConfig.rowSelection(selectedRows);
          },
          selectedRowKeys,
          // ...selectedRowKeysConfig,
        },
        setSelectedRowKeys,
      };
    } else if (props.selectType === 'radio') {
      return {
        rowSelection: {
          type: 'radio',
          onChange: (selectedRowKeys: React.Key[], selectedRows: Array<{ dataIndex: string }>) => {
            setSelectedRows(selectedRows);
            setSelectedRowKeys(selectedRowKeys);
            const MODULE_HANDLE = props?.recordInfo?.moduleLabel;
            props?.onSelectedRows && props.onSelectedRows(selectedRowKeys, selectedRows);
            eventsConfig?.rowSelection && eventsConfig.rowSelection(selectedRows.map(row => ({
              ...(row ?? {}),
              MODULE_HANDLE,
            })));
          },
          selectedRowKeys,
          // ...selectedRowKeysConfig,
        },
        setSelectedRowKeys,
      };
    } else {
      return {};
    }
  }, [props.selectType, props.selectedRowKeys, eventsConfig, selectedRowKeys]);
};


const getSelectedRowKeys = ({ selectedRowKeys }) => {
  if (selectedRowKeys === undefined) return;
  if (Array.isArray(selectedRowKeys)) {
    return selectedRowKeys;
  }
  return [selectedRowKeys];
};

export default useRowSelection;
